'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _color3 = require('../color');

var _color4 = _interopRequireDefault(_color3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var lightTheme = {
  primary: _color4.default.black,
  primaryInverse: _color4.default.white,
  secondary: _color4.default.gray4,
  background: _color4.default.white,
  backdrop: (0, _color2.default)(_color4.default.white).alpha(0.8).string(),
  selected: _color4.default.selected,
  link: _color4.default.link,
  disabled: _color4.default.gray3,
  shadow: _color4.default.black
};
exports.default = lightTheme;